import React, { useState } from 'react';
import '../../../../styles/global.css';
import './NiveisDeEnsino.css';

// Import placeholder images (replace with actual images)
import bercarioImg from '../../../../assets/images/bercario.jpg';
import infantilImg from '../../../../assets/images/infantil.jpg';
import fundamentalImg from '../../../../assets/images/fundamental.jpg';
import medioImg from '../../../../assets/images/medio.jpg';

const NiveisDeEnsino = () => {
  // Function to scroll to the Nossa Estrutura section
  const openWhatsApp = (e) => {
    if (e) e.preventDefault();
    const whatsappUrl = `https://tintim.link/whatsapp/82158fca-7f67-4721-83ea-295922f1f94d/d0ec74f7-1ac5-44ac-8414-0745a1880fe2?source=parceria-restaurantes`;
    window.open(whatsappUrl, '_blank');
  };

  // Array of education levels
  const niveis = [
    {
      id: 1,
      title: 'Berçário',
      description: 'Um ambiente acolhedor e seguro para os bebês, com estímulos adequados a cada fase do desenvolvimento da primeiríssima infância e das diversas linguagens. Nossos profissionais são capacitados em psicomotricidade, musicalização e primeiros cuidados.',
      image: bercarioImg,
      ages: '0 a 2 anos'
    },
    {
      id: 2,
      title: 'Educação Infantil',
      description: 'Atenção individualizada por meio de um currículo integrado e do Projeto de Educação Bilíngue. Com propostas diferenciadas, a criança é incentivada a desenvolver habilidades e competências essenciais para a vida, atuando com autonomia, empatia e pensamento criativo.',
      image: infantilImg,
      ages: '3 a 5 anos'
    },
    {
      id: 3,
      title: 'Ensino Fundamental',
      description: 'Formação acadêmica sólida, aliada ao desenvolvimento do pensamento crítico e da autonomia. Nosso currículo bilíngue prepara os alunos para os desafios do mundo contemporâneo.',
      image: fundamentalImg,
      ages: '6 a 14 anos'
    },
    {
      id: 4,
      title: 'Ensino Médio',
      description: 'Preparação para o vestibular e para a vida, incentivando o protagonismo, o autoconhecimento e a autonomia do estudante em suas escolhas profissionais. Oferecemos orientação vocacional e preparação com excelentes profissionais para o ENEM.',
      image: medioImg,
      ages: '15 a 17 anos'
    }
  ];

  // State to track the active slide
  const [activeSlide, setActiveSlide] = useState(0);

  // Function to navigate to next slide
  const nextSlide = () => {
    setActiveSlide((prev) => (prev === niveis.length - 1 ? 0 : prev + 1));
  };

  // Function to navigate to previous slide
  const prevSlide = () => {
    setActiveSlide((prev) => (prev === 0 ? niveis.length - 1 : prev - 1));
  };

  // Function to directly navigate to a specific slide
  const goToSlide = (index) => {
    setActiveSlide(index);
  };

  return (
    <section id="niveis-de-ensino" className="niveis-section-mobile">
      <div className="container">
        <div className="niveis-section-header-mobile">
          <h2>Do Berçário ao Ensino Médio</h2>
          <p>Educação completa em todas as fases do desenvolvimento</p>
        </div>

        <div className="niveis-carousel-container-mobile">
          <button className="niveis-carousel-arrow-mobile prev" onClick={prevSlide}>
            &#10094;
          </button>

          <div className="niveis-carousel-content-mobile">
            {niveis.map((nivel, index) => (
              <div 
                key={nivel.id} 
                className={`niveis-carousel-slide-mobile ${index === activeSlide ? 'active' : ''}`}
              >
                <div className="niveis-content-mobile">
                  <div className="niveis-image-mobile">
                    <img src={nivel.image} alt={nivel.title} />
                  </div>
                  <div className="niveis-text-mobile">
                    <h3>{nivel.title}</h3>
                    <span className="niveis-ages-mobile">{nivel.ages}</span>
                    <p>{nivel.description}</p>
                    <div className="niveis-cta-mobile">
                      <button 
                        className="niveis-whatsapp-button-mobile"
                        onClick={openWhatsApp}
                      >
                        <span className="whatsapp-icon-mobile">
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="16" height="16" fill="currentColor">
                            <path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"/>
                          </svg>
                        </span>
                        Agendar visita
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <button className="niveis-carousel-arrow-mobile next" onClick={nextSlide}>
            &#10095;
          </button>
        </div>

        <div className="niveis-carousel-indicators-mobile">
          {niveis.map((_, index) => (
            <button 
              key={index} 
              className={`niveis-indicator-mobile ${index === activeSlide ? 'active' : ''}`}
              onClick={() => goToSlide(index)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default NiveisDeEnsino; 